(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("wixFullstoryLoader", [], factory);
	else if(typeof exports === 'object')
		exports["wixFullstoryLoader"] = factory();
	else
		root["wixFullstoryLoader"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition